import { UtmKey } from '@synapex/tools/utils'

export const LinksQueryKeyConstants = {
    GroupsChannels: 'inviteLinksGroupsChannels',
    GroupsSites: 'inviteLinksGroupsSites',
    Sources: 'inviteLinksSources',
    Mediums: 'inviteLinksMediums',
    Campaigns: 'inviteLinksCampaigns',
    Contents: 'inviteLinksContents',
} as const

export const UTM_KEY = {
    content: { query: LinksQueryKeyConstants.Contents },
    medium: { query: LinksQueryKeyConstants.Mediums },
    campaign: { query: LinksQueryKeyConstants.Campaigns },
    source: { query: LinksQueryKeyConstants.Sources },
}

export const utmId = (key: UtmKey) => `utm_${key}_id` as const
